<div class="cc-loading-spinner" [class.cc-loading-spinner--absolute]="position === cssPosition.Absolute">
  <ccwb-spinner class="spinner" />
</div>
